import Vue from 'vue';
import BLRemodalPlugin from './BLRemodalPlugin';

Vue.use(BLRemodalPlugin);
